import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import i18n from 'i18next'
import Numeric from './Numeric'

@observer
class NumberForm extends Component {
    constructor(props) {
        super(props)
        const { store, question } = props
        const { form_data } = store
        if (question.settings.isCurrency) {
            this.state = {
                selectedCurrency: form_data.has(question.id)
                    ? form_data.get(question.id).metadata.unit
                    : this.setDefaultCurrency(),
            }
        }
    }

    questionGetTitle = (question) => {
        const { store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        let text = ''
        const titleObj = question.content.shortTitle
        if (titleObj[langcode]) {
            ({ text } = titleObj[langcode])
        } else if (titleObj[defaultLocale]) {
            ({ text } = titleObj[defaultLocale])
        } else if (titleObj[initialLocale]) {
            ({ text } = titleObj[initialLocale])
        }

        return store.replaceOptionMerge(text)
    }

    formOption = (option, index) => {
        const { store, question } = this.props

        let element = <Numeric />

        const validationMsg = option.question.hasOwnProperty('validator')
        && option.question.validator.error
        && !Object.values(option.question.validator.otherValidation).some(validation => validation.error)
            ? <div
                style={{
                    height: '25px', width: 0, position: 'relative', alignSelf: 'center',
                }}>
                <i className={'formValidationError validation_NFI fal fa-exclamation-circle'}></i>
            </div>
            : null

        element = React.cloneElement(element, {
            index,
            question: option.question,
            formId: question.id,
            store,
            printMode: store.printMode,
            numberForm: question,
            selectedCurrency: R.pathOr(undefined, ['state', 'selectedCurrency'], this),
            validationMsg,
        })

        const infoIconValues = option.question.settings.frontend.info

        const getText = (option) => {
            const { langcode } = store
            const { defaultLocale } = store.data.metadata
            const { initialLocale } = question

            let text = ''
            if (option[langcode]) {
                ({ text } = option[langcode])
            } else if (option[defaultLocale]) {
                ({ text } = option[defaultLocale])
            } else if (option[initialLocale]) {
                ({ text } = option[initialLocale])
            }

            return text
        }

        const infoIcon = infoIconValues
            ? (
                <div className="formInfoIcon">
                    <i className="fas fa-info-circle"></i>
                    <span className="tooltiptext top" dangerouslySetInnerHTML={{ __html: getText(infoIconValues) }}></span>
                </div>
            ) : null
        return (
            <div style={{ padding: '10px 0px', borderBottom: '1px solid #DDD', alignItems: 'center' }} className="formElement">
                <span className="formLabel">
                    {this.questionGetTitle(option.question)}
                </span>
                <div className={`formOption ${validationMsg ? 'optionValidationError' : ''}`}>
                    {element}
                </div>
                {infoIcon}
            </div>
        )
    }

    changeCurrency = (e) => {
        const { store, question } = this.props
        const { form_data } = store
        const newDataMap = form_data.has(question.id) ? form_data.get(question.id).data : new Map()

        store.addFormResponse(question, {
            data: newDataMap,
            metadata: { unit: e.target.value },
        })
        store.addNFCurrencyResponse(question, e.target.value)

        this.setState({ selectedCurrency: e.target.value })
    }

    setDefaultCurrency = () => {
        const { store, question } = this.props
        const { form_data } = store
        const newDataMap = form_data.has(question.id) ? form_data.get(question.id).data : new Map()
        if (store.data.currencyOptions.length < 2) {
            const defaultCurr = R.pathOr('USD', ['data', 'currencyOptions', 0, 'currency'], store)

            store.addFormResponse(question, {
                data: newDataMap,
                metadata: { unit: defaultCurr },
            })
            store.addNFCurrencyResponse(question, defaultCurr)
            return defaultCurr
        }
        return false
    }

    buildCurrencyOption() {
        const { question } = this.props
        const { store } = this.props


        const options = store.data.currencyOptions.map((co) => {
            const currencySymbol = i18n.t(`currency.symbols.${co.currency}`)
            return {
                label: `${co.currency} (${currencySymbol})`,
                name: co.currency,
                id: `${question.id}_${co.currency}`,
                checked: this.state.selectedCurrency === co.currency,
            }
        })

        return options.map(option => (
            <label
                className={`
                    ${(option.checked) ? 'single-multiple-choice-con__answer--selected' : ''}
                    radius
                    single-multiple-choice-con__answer 
                    radio-button
                    ${store.displayForMobile()
                ? 'single-multiple-choice-vertical-con__answer'
                : 'single-multiple-choice-horizontal-con__answer'}
                `}
                key={option.id}
            >
                <input type="radio"
                    name={'currencyRadio'}
                    value={option.name}
                    id={option.id}
                    defaultChecked={option.checked}
                    onChange={this.changeCurrency} />
                <span className="checkmark"></span>
                <span>{option.label}</span>
            </label>
        ))
    }

    showFormQuestions = () => {
        const { store, question } = this.props
        const { form_data } = store
        if (!question.settings.isCurrency) return true

        if (!form_data.has(question.id)) return false

        return form_data.get(question.id).metadata.unit
    }

    removeValidationErrors = () => {
        const { question } = this.props
        question.optionSet.forEach((option) => {
            if (R.pathOr(false, ['question', 'validator', 'error'], option)) {
                option.question.validator.error = false
            }
        })
    }

    render() {
        const { question, store } = this.props
        const validationErrors = question.optionSet.filter(o => o.question.validator.error)
        return (
            <div className={`formQuestion ${validationErrors.length > 0 ? 'validationError' : ''}`} onFocus={this.removeValidationErrors}>
                <div className="validationContainer" style={{ marginBottom: '10px' }}>
                    {validationErrors.length > 0
                        ? <span className="validationError radius">
                            <i className="fal fa-exclamation-triangle"></i>
                            {i18n.t('validation.question.form.required')}
                        </span>
                        : null}
                </div>
                {question.settings.isCurrency && store.data.currencyOptions.length > 1
                    ? (<div
                        className={'single-multiple-choice-horizontal-con'}
                        style={(R.pathOr(false, ['settings', 'nonRequired'], question) && this.showFormQuestions())
                            ? { marginBottom: '35px' } : {}}
                    >
                        {this.buildCurrencyOption()}
                    </div>)
                    : null}
                {this.showFormQuestions() ? question.optionSet.map(this.formOption) : null}
            </div>
        )
    }
}

export default NumberForm
